const credits = [
	{
		title: 'Office Pixel Art Assets',
		author: 'Antea ✮⋆˙',
		category: 'Assets',
		license: 'CC BY 4.0',
		licenseUrl: 'https://creativecommons.org/licenses/by/4.0/',
		url: 'https://stcrbcn.itch.io/furniture-office-set',
		notes:
			'No generative AI was used. Includes 16×16 and 32×32 sprites — office furniture, objects, and top-down pixel art.',
	},
];

export default credits;
